const config = {
  productionMode: false,

  event: {
    title: 'Portland Megaband Dance 2027',
    titleWithYear: 'Portland Megaband Dance 2027', // must match backend config
    location: 'Portland, Oregon',
    date: 'March 13, 2027',
    timezone: 'America/Los_Angeles'
  },

  calendar: {
    title: 'Portland Megaband Dance',
    description: 'Join us for the 2027 Portland Megaband Dance! More details at https://portlandmegaband.com',
    location: 'Smith Memorial Ballroom, Portland, OR',
    start: '2027-03-13T19:15:00-07:00', // ISO 8601 format
    end: '2027-03-13T22:30:00-07:00' // ISO 8601 format
  },

  contacts: {
    info: 'contra@portlandcountrydance.org',
    tech: 'ash@pdxcontra.org',
    housing: 'contra@portlandcountrydance.org'
  },

  links: {
    info: 'portlandmegaband.com',
    policies: {
      covid: 'portlandcountrydance.org/covid19/',
      safety: 'portlandcountrydance.org/files/PCDC-CodeofConduct.pdf'
    }
  },

  nametags: {
    includePronouns: true,
    includeLastName: true
  },

  staticPages: {
    enabled: false,
    components: ['Home', 'About', 'Staff', 'Seattle', 'Contact', 'Schedule', 'PaymentExplanation'], // These must exist in src/components/Static
  },

  registration: {
    waitlistMode: false,
    showPreregistration: false,
    showWaiver: false,
    admissionQuantityMax: 4,
    fields: { // Order of form fields
      contact: ['first', 'last', 'email', 'emailConfirmation', 'phone'],
      misc: []
    }
  },

  admissions: {
    mode: 'sliding-scale', // sliding-scale|fixed|tiered
    slidingScale: {
      costRange: [15, 40],
      costDefault: 25
    },
    fixed: {
      cost: 200
    },
    tiered: {
      earlybirdCutoff: '2025-11-10', // last day to get early pricing
    }
  },

  payments: {
    processor: 'paypal', // stripe|paypal - also must set in backend config
    paymentDueDate: 'Example Payment Due Date',
    directPaymentUrl: 'example.com/directpayment', // electronic payment option to pay remaining balance after selecting deposit or check payment
    coverFeesCheckbox: true,
    showPaymentSummary: true, // show summary of costs in payment section
    deposit: {
      enabled: false,
      amount: 50 // ignored if disabled
    },
    donation: {
      enabled: true,
      max: 999 // ignored if disabled
    },
    checks: {
      allowed: false, // If false, the below fields are ignored
      showPostalAddress: false, // If false, shows contact email
      payee: 'Example Check Payee Name',
      address: ['Line 1', 'Line 2', 'Line 3', 'Line 4']
    }
  }
};

export default config;